/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-ajax-save-on-check]';
const PLUGIN_NAME = 'ajaxSaveOnCheck';
const MODULE_NAME = 'app.core/modules/ajax-save-on-check';
const log = debug(MODULE_NAME);


log('registerd');

class AjaxSaveOnCheck {

	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);
		this.isChecked = this.$element.is(':checked');
		this.endPointParam = this.$element.attr('name');
		this.endpointUrl =  $(`meta[name="site.${this.$element.attr(this.options.endpointMethodAttr)}"]`).attr('content');
		this.$element.on('click', this.check.bind(this));
	}

	check () {
	  this.isChecked = this.$element.is(':checked');
	  log('change', this.$element, this.isChecked, this.initial);
	  this.submit();
	}

	submit() {
		this.inputValue = this.isChecked ? "1" : "0";
		log('submitted', this.$element);
		this.$element.attr('disabled', 'disabled');
		this.post();
	}

	onSuccess(result) {
		this.$element.removeAttr('disabled');

		if (typeof result.Success !== 'undefined' && result.Success) {
		}
		else {
			var errorList =
				typeof result.ValidationMessages !== 'undefined'
					? result.ValidationMessages
					: Array();
			log('AjaxSaveOnCheckServerError', errorList);
			this.$element.val(this.initial);
		}
	}

	post() {
		const url = `${this.endpointUrl}?${this.endPointParam}=${this.inputValue}`;

		var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
		log('accepting', this.$element, url);
		$.ajax({
			url,
			method: 'post',
			data: {
				__RequestVerificationToken: token
			},
			success: result => {
				this.onSuccess(result);
			},
			error: e => {
				log('AjaxSaveOnCheckAjaxError', e);
			  this.$element.removeAttr('disabled');
			  this.$element.val(this.initial);
			}
		}).done(() => {
			log('accepted', this.$element, url);
		});
	}

}

AjaxSaveOnCheck.DEFAULTS = {
	endpointMethodAttr: 'data-endpoint-method',
	submitErrorClassname: 'submit-error'
};

plugin(PLUGIN_NAME, AjaxSaveOnCheck);

export function exec () {
  $(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/ajax-save-on-check/index.js